import React, { useEffect, useState } from "react";

const STORAGE_KEY = "ld_cookie_consent";

export function getCookieConsent() {
  if (typeof window === "undefined") return null;
  return localStorage.getItem(STORAGE_KEY);
}

const CookieConsent = ({ policyHref = "/cookie-policy" }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const existing = getCookieConsent();
    if (!existing) {
      const t = setTimeout(() => setVisible(true), 900);
      return () => clearTimeout(t);
    }
  }, []);

  const choose = (accepted) => {
    localStorage.setItem(STORAGE_KEY, accepted ? "accepted" : "rejected");
    setVisible(false);
    window.dispatchEvent(
      new CustomEvent("cookie-consent-changed", {
        detail: accepted ? "accepted" : "rejected",
      })
    );
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4 animate-slideUp">
      <div className="max-w-3xl mx-auto bg-white dark:bg-gray-800 border border-black/10 dark:border-white/10 rounded-2xl shadow-xl p-5 flex flex-col sm:flex-row items-start sm:items-center gap-4 justify-between">
        <p className="text-sm text-muted2 dark:text-gray-400">
          We use cookies to keep you signed in and improve your experience.{" "}
          <a href={policyHref} className="text-brandviolet-500 dark:text-brandviolet-400 underline">
            Read our cookie policy
          </a>
          .
        </p>
        <div className="flex gap-2 shrink-0 w-full sm:w-auto">
          <button
            onClick={() => choose(false)}
            className="flex-1 sm:flex-none px-4 py-2 rounded-lg text-sm text-gray-700 dark:text-gray-200 border border-black/10 dark:border-white/15 hover:bg-black/5 dark:hover:bg-white/10 transition-colors"
          >
            Reject
          </button>
          <button
            onClick={() => choose(true)}
            className="flex-1 sm:flex-none px-4 py-2 rounded-lg text-sm bg-brandviolet-500 hover:bg-brandviolet-600 text-white font-semibold transition-colors"
          >
            Accept all
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;